import './ChoiceCard.scss';
import { Input } from 'antd';
import { RxCross2 } from 'react-icons/rx';
import React from 'react';

function ChoiceCard({ index, question, answers, id, handleDelete, setDataAI }) {
  const handleUpdateData = (e, cardId, answerId = null) => {
    const { name, value, checked } = e.target;

    setDataAI((prevState) =>
      prevState.map((card) => {
        if (card.id !== cardId) return card;

        if (name === 'question') {
          return { ...card, question: value };
        }

        if (name === 'answers' || name === 'answerText') {
          return {
            ...card,
            answers: card.answers.map((answer) => {
              if (answer.id !== answerId) return answer;

              return {
                ...answer,
                ...(name === 'answers' ? { checked } : { text: value }),
              };
            }),
          };
        }

        return card;
      })
    );
  };
  return (
    <div className="choice-card-container">
      <div className="choice-card-index-badge">
        <span>{index}</span>
      </div>
      <div className="choice-card-content">
        <Input.TextArea
          name="question"
          value={question}
          className="choice-card-question"
          onChange={(e) => handleUpdateData(e, id)}
        />
        <div className="choice-card-answers">
          {answers?.map((answer) => (
            <div className="choice-card-answer" key={answer?.id}>
              <Input
                className="choice-card-answer-text"
                value={answer?.text}
                name="answerText"
                onChange={(e) => handleUpdateData(e, id, answer?.id)}
              />
              <input
                name="answers"
                type="checkbox"
                checked={answer?.checked}
                value={answer?.id}
                className="choice-card-answer-checkbox"
                onChange={(e) => handleUpdateData(e, id, answer?.id)}
              />
            </div>
          ))}
        </div>
        <div className="choice-card-remove">
          <RxCross2
            onClick={() => {
              handleDelete(id);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default ChoiceCard;
